export const data=[
    {
        imgSrc:require('../../../assets/lineSimple.png'),
        code:`import { LineChart } from "react-native-gifted-charts";
        
const App = () => {
    const data = [{value: 15}, {value: 30}, {value: 26}, {value: 40}];
    return <LineChart data={data}/>;
};`
    },
    //2
    {
        imgSrc:require('../../../assets/lineStyled.png'),
        code:`import { LineChart } from "react-native-gifted-charts";
        
const App = () => {
    const data = [{value: 15}, {value: 30}, {value: 26}, {value: 40}];
    return (
        <LineChart
        data={lineData}
        color={'#177AD5'}
        thickness={3}
        dataPointsColor={'red'}
      />
    );
};`
    },
    //3
    {
        imgSrc:require('../../../assets/line.png'),
        code:`import { LineChart } from "react-native-gifted-charts"
const App = () => {
  const lineData = [{value: 0},{value: 20},{value: 18},{value: 40},{value: 36},{value: 60},{value: 54},{value: 85}]
  return (
      <View style={{backgroundColor: '#1A3461'}}>
          <LineChart
              initialSpacing={0}
              data={lineData}
              spacing={30}
              hideDataPoints
              thickness={5}
              hideRules
              hideYAxisText
              yAxisColor="#0BA5A4"
              showVerticalLines
              verticalLinesColor="rgba(14,164,164,0.5)"
              xAxisColor="#0BA5A4"
              color="#0BA5A4"
          />
      </View>
  );
};`
    },
    // 4
    {
        imgSrc:require('../../../assets/line.png'),
        code:`import { LineChart } from "react-native-gifted-charts"
const App = () => {
  const lineData = [
      {value: 0, dataPointText: '0'},
      {value: 20, dataPointText: '20'},
      {value: 18, dataPointText: '18'},
      {value: 40, dataPointText: '40'},
      {value: 36, dataPointText: '36'},
      {value: 60, dataPointText: '60'},
      {value: 54, dataPointText: '54'},
      {value: 85, dataPointText: '85'}
  ];
  return (
      <View style={{backgroundColor: '#1A3461'}}>
          <LineChart
              initialSpacing={0}
              data={lineData}
              spacing={30}
              textColor1="yellow"
              textShiftY={-8}
              textShiftX={-10}
              textFontSize={13}
              thickness={5}
              hideRules
              hideYAxisText
              yAxisColor="#0BA5A4"
              showVerticalLines
              verticalLinesColor="rgba(14,164,164,0.5)"
              xAxisColor="#0BA5A4"
              color="#0BA5A4"
          />
      </View>
  );
};`
    },
    // 5
    {
        imgSrc:require('../../../assets/lines2.png'),
        code:`import { LineChart } from "react-native-gifted-charts"
const App = () => {
  const lineData = [
      {value: 0, dataPointText: '0'},
      {value: 10, dataPointText: '10'},
      {value: 8, dataPointText: '8'},
      {value: 58, dataPointText: '58'},
      {value: 56, dataPointText: '56'},
      {value: 78, dataPointText: '78'},
      {value: 74, dataPointText: '74'},
      {value: 98, dataPointText: '98'},
    ];
  
    const lineData2 = [
      {value: 0, dataPointText: '0'},
      {value: 20, dataPointText: '20'},
      {value: 18, dataPointText: '18'},
      {value: 40, dataPointText: '40'},
      {value: 36, dataPointText: '36'},
      {value: 60, dataPointText: '60'},
      {value: 54, dataPointText: '54'},
      {value: 85, dataPointText: '85'},
    ];
  return (
      <View>
          <LineChart
          data={lineData}
          data2={lineData2}
          height={250}
          showVerticalLines
          spacing={44}
          initialSpacing={0}
          color1="skyblue"
          color2="orange"
          textColor1="green"
          dataPointsHeight={6}
          dataPointsWidth={6}
          dataPointsColor1="blue"
          dataPointsColor2="red"
          textShiftY={-2}
          textShiftX={-5}
          textFontSize={13}
      />
      </View>
  );
};`
    },
    //6
    {
      imgSrc:require('../../../assets/segmentBreaks.png'),
      code:`import { LineChart } from "react-native-gifted-charts"
const MultiSegmented = () => {
  const data = [
    {value: 5},
    {value: 8},
    {value: 7}, // break in line from previous to this point
    {value: 4},
    {value: 6},
    {value: 0, hideDataPoint: true}, // invisible, here's a break in the line
    {value: 0, hideDataPoint: true}, // break continued
    {value: 6},
    {value: 9},
  ];
  return (
    <LineChart
      spacing={35}
      data={data}
      lineSegments={[
        {startIndex: 0, endIndex: 1, color: 'green'},             // 1st segmant from 0th to 1st index
        {startIndex: 1, endIndex: 2, color: 'transparent'},       // break (transparent = invisible)
        {startIndex: 2, endIndex: 4, color: 'red'},               // 2nd segment from 2nd to 4th index
        {startIndex: 4, endIndex: 7, color: 'transparent'},       // 2nd break from 4th to 7th index
        // remaining of the data points, from 7th to 8th index make the last segment
      ]}
    />
  );
};`
    },
    //7
    {
      imgSrc: 'https://github.com/Abhinandan-Kushwaha/chart-images/blob/main/screenshots/secondary.png?raw=true',
      code: `import { LineChart } from "react-native-gifted-charts"
const App = () => {
const d1 = [
  {value: 110},
  {value: 90},
  {value: 100},
  {value: 120},
  {value: 100, label: '2005', showXAxisIndex: true},
  {value: 80},
  {value: 90},
  {value: 110},
  {value: 120},
  {value: 100, label: '2010', showXAxisIndex: true},
  {value: 90},
  {value: 100},
  {value: 88},
  {value: 80},
  {value: 120, label: '2015', showXAxisIndex: true},
  {value: 76},
  {value: 104},
  {value: 112},
];
const d2 = [
  0.055, 0.02, 0.1, 0.01, 0.05, 0.06, 0.08, 0.1, 0.08, 0.07, 0.06, 0.025,
  0.04, 0.06, 0.045, 0.09, 0.06, 0.04,
];

return (
  <View style={{marginTop: 100}}>
    <LineChart
      data={d1}
      maxValue={140}
      noOfSections={7}
      spacing={16}
      hideDataPoints
      hideRules
      color="orange"
      yAxisColor={'orange'}
      showYAxisIndices
      yAxisIndicesColor={'orange'}
      yAxisIndicesWidth={10}
      secondaryData={d2.map(v => ({value: v}))}
      secondaryLineConfig={{color: 'blue'}}
      secondaryYAxis={{
        maxValue: 0.2,
        noOfSections: 4,
        showFractionalValues: true,
        roundToDigits: 3,
        yAxisColor: 'blue',
        yAxisIndicesColor: 'blue',
      }}
      xAxisLabelTextStyle={{width: 80, marginLeft: -36}}
      xAxisIndicesHeight={10}
      xAxisIndicesWidth={2}
    />
  </View>
);`
    },
    // 8
    {
        imgSrc:require('../../../assets/animatedDataLine.gif'),
        code:`import { LineChart } from "react-native-gifted-charts"
const App = () => {
const [currentData, setCurrentData] = useState(latestData);
const latestData = [
    {
      value: 100,
      labelComponent: () => lcomp('22 Nov'),
      customDataPoint: dPoint,
    },
    {
      value: 120,
      hideDataPoint: true,
    },
    {
      value: 210,
      customDataPoint: dPoint,
    },
    {
      value: 250,
      hideDataPoint: true,
    },
    {
      value: 320,
      labelComponent: () => lcomp('24 Nov'),
      customDataPoint: dPoint,
    },
    {
      value: 310,
      hideDataPoint: true,
    },
    {
      value: 270,
      customDataPoint: dPoint,
    },
    {
      value: 240,
      hideDataPoint: true,
    },
    {
      value: 130,
      labelComponent: () => lcomp('26 Nov'),
      customDataPoint: dPoint,
    },
    {
      value: 120,
      hideDataPoint: true,
    },
    {
      value: 100,
      customDataPoint: dPoint,
    },
    {
      value: 210,
      hideDataPoint: true,
    },
    {
      value: 270,
      labelComponent: () => lcomp('28 Nov'),
      customDataPoint: dPoint,
    },
    {
      value: 240,
      hideDataPoint: true,
    },
    {
      value: 120,
      hideDataPoint: true,
    },
    {
      value: 100,
      customDataPoint: dPoint,
    },
    {
      value: 210,
      labelComponent: () => lcomp('28 Nov'),
      customDataPoint: dPoint,
    },
    {
      value: 20,
      hideDataPoint: true,
    },
    {
      value: 100,
      customDataPoint: dPoint,
    },
  ];
  const dPoint = () => {
    return (
      <View
        style={{
          width: 14,
          height: 14,
          backgroundColor: 'white',
          borderWidth: 3,
          borderRadius: 7,
          borderColor: '#07BAD1',
        }}
      />
    );
  };
return (
    <View>
      <View
        style={{
          marginVertical: 100,
          paddingVertical: 50,
          backgroundColor: '#414141',
        }}>
        <LineChart
          isAnimated
          thickness={3}
          color="#07BAD1"
          maxValue={600}
          noOfSections={3}
          animateOnDataChange
          animationDuration={1000}
          onDataChangeAnimationDuration={300}
          areaChart
          yAxisTextStyle={{color: 'lightgray'}}
          data={currentData}
          hideDataPoints
          startFillColor={'rgb(84,219,234)'}
          endFillColor={'rgb(84,219,234)'}
          startOpacity={0.4}
          endOpacity={0.1}
          spacing={22}
          backgroundColor="#414141"
          rulesColor="gray"
          rulesType="solid"
          initialSpacing={10}
          yAxisColor="lightgray"
          xAxisColor="lightgray"
        />
      </View>
    </View>
    );
};`
    },
// 9
{
  imgSrc:require('../../../assets/multiColorY.png'),
  code: `import { LineChart } from "react-native-gifted-charts"
  const App = () => {
  const data = [{value: 10}, {value: 15}, {value: 2}, {value: 19.6}];
  const data2 = [{value: 9}, {value: 4}, {value: 12}, {value: 1}];

  return <LineChart
    data={data}
    data2={data2}
    thickness={4}
    height={200}
    curved
    hideDataPoints
    referenceLine1Position={7}
    showReferenceLine1
    referenceLine2Position={11}
    showReferenceLine2
    referenceLine3Position={15}
    showReferenceLine3
    hideRules
    colors={[
      {
        from: 0,
        to: 3,
        color: 'red',
      },
      {
        from: 3,
        to: 7,
        color: 'orange',
      },
      {
        from: 7,
        to: 11,
        color: 'brown',
      },
      {
        from: 11,
        to: 15,
        color: 'green',
      },
      {
        from: 15,
        to: 20,
        color: 'blue',
      },
    ]}
  />`
}
]

// yAxisOffset

export const specialData = `const data = [
  {value: 110},
  {value: 130},
  {value: 120},
  {value: 160},
  {value: 190},
];`

export const specialCode = `const data = [
  {value: 110},
  {value: 130},
  {value: 120},
  {value: 160},
  {value: 190},
];

return (
<LineChart
  data = {data}
  yAxisOffset={100}
/>`

export const lineChartBiColor = `<LineChartBicolor
  data={data}
  areaChart
  color="green"
  colorNegative="red"
  startFillColor="green"
  startFillColorNegative="red"
/>`

export const multiColorCustomGradientLineChart = `<LineChart
data={lineData}
spacing={10}
hideDataPoints
lineGradient
lineGradientId="ggrd" // same as the id passed in <LinearGradient> below
lineGradientComponent={() => {
  return (
    <LinearGradient id="ggrd" x1="0" y1="0" x2="0" y2="1">
      <Stop offset="0" stopColor={'blue'} />
      <Stop offset="0.5" stopColor={'orange'} />
      <Stop offset="1" stopColor={'green'} />
    </LinearGradient>
  );
}}
/>`

export const highlightedRange = `import React from 'react';
import {LineChart} from 'react-native-gifted-charts';

const App = () => {
    const data = [
        {value: 6},
        {value: 6},
        {value: 8},
        {value: 5},
        {value: 5},
        {value: 8},
        {value: 0},
        {value: 8},
        {value: 10},
        {value: 10},
        {value: 12},
        {value: 15},
        {value: 20},
        {value: 22},
        {value: 20}
      ];
    
      return (
        <LineChart
          data={data}
          spacing={22}
          thickness={5}
          color='red'
          hideRules
          hideDataPoints
          xAxisThickness={0}
          yAxisThickness={0}
          highlightedRange={{
            from: 5,
            to: 12,
            color: 'green',
          }}
        />
      );
};

export default App;
`

export const colorsType = `type ColorFromToY = {
  from: number
  to: number
  color: ColorValue
}`